(function () {
  'use strict';

  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var ITEM_ANIMATION_TYPES = ['fade_slide', 'fade', 'slide', 'scale'];
  var ITEM_ANIMATION_EASES = ['power1.out', 'power2.out', 'power3.out', 'back.out(1.2)'];

  function getNumber(value, fallback, min, max) {
    var number = Number(value);
    if (!Number.isFinite(number)) return fallback;
    if (typeof min === 'number' && number < min) return min;
    if (typeof max === 'number' && number > max) return max;
    return number;
  }

  function getItemAnimationConfig(section) {
    var animationType = section.dataset.membersWeekItemAnimationType || 'fade_slide';
    var animationEase = section.dataset.membersWeekItemAnimationEase || 'power3.out';

    if (ITEM_ANIMATION_TYPES.indexOf(animationType) === -1) {
      animationType = 'fade_slide';
    }

    if (ITEM_ANIMATION_EASES.indexOf(animationEase) === -1) {
      animationEase = 'power3.out';
    }

    return {
      enabled: section.dataset.membersWeekItemAnimationEnabled !== 'false',
      type: animationType,
      duration: getNumber(section.dataset.membersWeekItemAnimationDuration, 320, 0, 2000) / 1000,
      exitDuration: getNumber(section.dataset.membersWeekItemAnimationExitDuration, 160, 0, 1000) / 1000,
      stagger: getNumber(section.dataset.membersWeekItemAnimationStagger, 35, 0, 500) / 1000,
      distance: getNumber(section.dataset.membersWeekItemAnimationDistance, 14, 0, 100),
      scale: getNumber(section.dataset.membersWeekItemAnimationScale, 98, 1, 100) / 100,
      ease: animationEase
    };
  }

  function getItemFromVars(config) {
    var vars = { autoAlpha: 0 };

    if (config.type === 'fade_slide' || config.type === 'slide') {
      vars.y = config.distance;
    }

    if (config.type === 'fade_slide' || config.type === 'scale') {
      vars.scale = config.scale;
    }

    return vars;
  }

  function getItemToVars(config) {
    var vars = {
      autoAlpha: 1,
      duration: config.duration,
      ease: config.ease,
      overwrite: 'auto'
    };

    if (config.stagger > 0) {
      vars.stagger = config.stagger;
    }

    if (config.type === 'fade_slide' || config.type === 'slide') {
      vars.y = 0;
    }

    if (config.type === 'fade_slide' || config.type === 'scale') {
      vars.scale = 1;
    }

    return vars;
  }

  function getItemExitVars(config) {
    var vars = {
      autoAlpha: 0,
      duration: config.exitDuration,
      ease: config.ease,
      overwrite: 'auto'
    };

    if (config.type === 'fade_slide' || config.type === 'slide') {
      vars.y = config.distance;
    }

    if (config.type === 'fade_slide' || config.type === 'scale') {
      vars.scale = config.scale;
    }

    return vars;
  }

  function getVisibleItems(section, brand) {
    return Array.prototype.slice.call(section.querySelectorAll('[data-members-week-item]')).filter(function (item) {
      var itemBrand = item.getAttribute('data-members-week-item-brand');
      return itemBrand === brand || itemBrand === 'both';
    });
  }

  function getElementLabel(element) {
    if (!element) return '';

    var desktopLabel = element.querySelector('.members-week-navigation__label--desktop');
    var mobileLabel = element.querySelector('.members-week-navigation__label--mobile');
    var labelElement = desktopLabel || mobileLabel || element;

    return labelElement.textContent.replace(/\s+/g, ' ').trim();
  }

  function notifyNavigationChange(section, label, brand) {
    document.dispatchEvent(new CustomEvent('members-week:navigation-change', {
      detail: {
        section: section,
        label: label,
        brand: brand
      }
    }));
  }

  function getProductSections(section) {
    var selector = section.dataset.membersWeekProductSectionSelector || '[data-home-tab-products]';
    var sections = [];

    try {
      sections = Array.prototype.slice.call(document.querySelectorAll(selector));
    } catch (error) {
      sections = Array.prototype.slice.call(document.querySelectorAll('[data-home-tab-products]'));
    }

    return sections.filter(function (productSection) {
      return productSection !== section && !section.contains(productSection);
    });
  }

  function getSectionHost(productSection) {
    return productSection.closest('.shopify-section') || productSection;
  }

  function showProductSection(section, sectionIndex) {
    var sections = getProductSections(section);
    var targetIndex = Math.max(getNumber(sectionIndex, 1, 1, 99) - 1, 0);
    var target = sections[targetIndex] || sections[0];

    if (!target) return null;

    if (sections.length > 1) {
      sections.forEach(function (productSection) {
        var host = getSectionHost(productSection);
        var isActive = productSection === target;
        host.hidden = !isActive;
        host.classList.toggle('members-week-product-section--active', isActive);
      });
    }

    return target;
  }

  function getProductTabsForBrand(tabs, brand) {
    if (brand !== 'primary' && brand !== 'secondary') return [];

    return tabs.filter(function (tab) {
      var group = tab.getAttribute('data-members-week-button-group') || 'primary';
      if (group === brand) return true;
      return brand === 'primary' && group === 'both';
    });
  }

  function activateProductTarget(section, sectionIndex, tabIndex, brand) {
    var productSection = showProductSection(section, sectionIndex);
    if (!productSection) return false;

    var targetTabIndex = getNumber(tabIndex, -1, -1, 99);
    if (targetTabIndex < 0) return true;

    var tabs = Array.prototype.slice.call(productSection.querySelectorAll('[data-home-tab-btn]'));
    var visibleTabs = tabs.filter(function (tab) {
      return !tab.hidden && !tab.classList.contains('members-week-filter-hidden');
    });
    var brandTabs = getProductTabsForBrand(tabs, brand);
    var targetTabs = brandTabs.length > 0 ? brandTabs : visibleTabs.length > 0 ? visibleTabs : tabs;
    var targetTab = targetTabs[targetTabIndex] || targetTabs[0];
    if (!targetTab) return true;

    if (!targetTab.classList.contains('active')) {
      targetTab.click();
    }

    return true;
  }

  function setActiveItem(section, item) {
    if (!item) return;

    var items = section.querySelectorAll('[data-members-week-item]');
    var itemBrand = item.getAttribute('data-members-week-item-brand');
    var activeBrandTab = section.querySelector('[data-members-week-brand-tab].is-active');
    var targetBrand = itemBrand === 'both' && activeBrandTab
      ? activeBrandTab.getAttribute('data-members-week-brand')
      : itemBrand;

    items.forEach(function (navItem) {
      var isActive = navItem === item;
      navItem.classList.toggle('is-active', isActive);
      navItem.setAttribute('aria-current', isActive ? 'true' : 'false');
    });

    activateProductTarget(
      section,
      item.getAttribute('data-members-week-product-section-index'),
      item.getAttribute('data-members-week-product-tab-index'),
      targetBrand
    );
    notifyNavigationChange(section, getElementLabel(item), targetBrand);
  }

  function getBrandProductSectionIndex(section, brand, activeTab) {
    if (activeTab && activeTab.getAttribute('data-members-week-product-section-index')) {
      return activeTab.getAttribute('data-members-week-product-section-index');
    }

    if (brand === 'secondary') {
      return section.dataset.membersWeekSecondaryProductSectionIndex || 1;
    }

    return section.dataset.membersWeekPrimaryProductSectionIndex || 1;
  }

  function getTabLabel(tab) {
    if (!tab) return '';
    return tab.getAttribute('data-members-week-button-label') || tab.textContent.trim();
  }

  function notifyProducts(section, brand, activeTab) {
    var detail = {
      brand: brand || 'primary',
      label: getTabLabel(activeTab),
      source: section
    };

    window.FilaMembersWeekActiveProductGroup = detail;

    document.dispatchEvent(new CustomEvent('members-week-navigation:change', {
      detail: detail
    }));
  }

  function movePill(section, tab, animate) {
    var pill = section.querySelector('[data-members-week-active-pill]');
    var tabsWrap = section.querySelector('[data-members-week-brand-tabs]');
    if (!pill || !tabsWrap || !tab) return;

    var wrapRect = tabsWrap.getBoundingClientRect();
    var tabRect = tab.getBoundingClientRect();
    var props = {
      x: tabRect.left - wrapRect.left,
      width: tabRect.width
    };

    if (window.gsap && animate && !REDUCED_MOTION.matches) {
      window.gsap.to(pill, {
        x: props.x,
        width: props.width,
        duration: 0.34,
        ease: 'power3.out',
        overwrite: 'auto'
      });
      return;
    }

    pill.style.transform = 'translateX(' + props.x + 'px)';
    pill.style.width = props.width + 'px';
  }

  function applyProductOriginBrandTabVisibility(section) {
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-members-week-brand-tab]'));
    var visibleCount = 0;

    tabs.forEach(function (tab) {
      tab.hidden = false;
      tab.setAttribute('aria-hidden', 'false');
      tab.tabIndex = 0;
      visibleCount += 1;
    });

    section.style.setProperty('--mwn-brand-tab-count', visibleCount || tabs.length || 1);
  }

  function setActive(section, brand, animate) {
    var tabs = section.querySelectorAll('[data-members-week-brand-tab]');
    var items = section.querySelectorAll('[data-members-week-item]');
    var activeTab = null;
    var animationConfig = getItemAnimationConfig(section);

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute('data-members-week-brand') === brand;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) activeTab = tab;
    });

    var visibleItems = getVisibleItems(section, brand);
    var nextActiveItem = visibleItems.filter(function (item) {
      return item.classList.contains('is-active');
    })[0] || visibleItems[0];
    notifyProducts(section, brand, activeTab);

    if (window.gsap && animate && animationConfig.enabled && !REDUCED_MOTION.matches) {
      var exitVars = getItemExitVars(animationConfig);
      window.gsap.killTweensOf(items);
      exitVars.onComplete = function () {
        items.forEach(function (item) {
          item.classList.toggle('is-visible', visibleItems.indexOf(item) !== -1);
        });
        if (nextActiveItem) {
          setActiveItem(section, nextActiveItem);
        } else {
          showProductSection(section, getBrandProductSectionIndex(section, brand, activeTab));
          notifyNavigationChange(section, getElementLabel(activeTab), brand);
        }
        window.gsap.fromTo(
          visibleItems,
          getItemFromVars(animationConfig),
          getItemToVars(animationConfig)
        );
      };
      window.gsap.to(items, exitVars);
    } else {
      items.forEach(function (item) {
        item.classList.toggle('is-visible', visibleItems.indexOf(item) !== -1);
        item.style.opacity = '';
        item.style.visibility = '';
        item.style.transform = '';
      });
      if (nextActiveItem) {
        setActiveItem(section, nextActiveItem);
      } else {
        showProductSection(section, getBrandProductSectionIndex(section, brand, activeTab));
        notifyNavigationChange(section, getElementLabel(activeTab), brand);
      }
    }

    movePill(section, activeTab, animate);
    refreshStickyNav(section);
  }

  function refreshStickyNav(section) {
    if (!window.ScrollTrigger) return;
    window.requestAnimationFrame(function () {
      window.ScrollTrigger.refresh();
    });
  }

  function getScrollPinTopFromDataset(section) {
    var topValue = section.dataset.membersWeekScrollPinTop;

    if (topValue == null || topValue === '') {
      topValue = section.dataset.membersWeekScrollPinStartOffset;
    }

    return getNumber(topValue, 0, 0, 400);
  }

  function getScrollPinTopSetting(section) {
    return getScrollPinTopFromDataset(section);
  }

  function isAnnouncementBarVisible(announcementSection, utilityBar) {
    if (!announcementSection || !utilityBar) return false;
    if (utilityBar.classList.contains('hidden')) return false;

    var utilityStyle = window.getComputedStyle(utilityBar);
    if (utilityStyle.display === 'none' || utilityStyle.visibility === 'hidden') return false;

    return announcementSection.getBoundingClientRect().height > 0;
  }

  function getAnnouncementBarOffset() {
    var announcementSection = document.querySelector('.announcement-bar-section');
    if (!announcementSection) return 0;

    var utilityBar = announcementSection.querySelector('.utility-bar');
    if (!isAnnouncementBarVisible(announcementSection, utilityBar)) return 0;

    return Math.round(announcementSection.getBoundingClientRect().height) || 0;
  }

  function getPinStartOffset(section) {
    var config = getScrollPinConfig(section);
    var y = getScrollPinTopFromDataset(section) + getAnnouncementBarOffset();

    if (config.includeHeader) {
      y += getHeaderOffset();
    }

    return Math.max(0, y);
  }

  function applyScrollPinTopVars(section, pinTarget) {
    if (!section) return;

    var config = getScrollPinConfig(section);
    var rawTop = getScrollPinTopFromDataset(section);
    var totalTop = getPinStartOffset(section);
    var announcementOffset = getAnnouncementBarOffset();
    var headerOffset = config.includeHeader ? getHeaderOffset() : 0;

    section.style.setProperty('--mwn-scroll-pin-top', rawTop + 'px');
    section.style.setProperty('--mwn-scroll-pin-y', totalTop + 'px');
    section.style.setProperty('--mwn-scroll-pin-announcement-offset', announcementOffset + 'px');
    section.style.setProperty('--mwn-scroll-pin-header-offset', headerOffset + 'px');

    if (!pinTarget) return;

    pinTarget.style.setProperty('--mwn-scroll-pin-top', rawTop + 'px');
    pinTarget.style.setProperty('--mwn-scroll-pin-y', totalTop + 'px');
    pinTarget.style.setProperty('--mwn-scroll-pin-announcement-offset', announcementOffset + 'px');
    pinTarget.style.setProperty('--mwn-scroll-pin-header-offset', headerOffset + 'px');

    if (pinTarget.classList.contains('is-scroll-pinned')) {
      pinTarget.style.position = 'fixed';
      pinTarget.style.top = totalTop + 'px';
    } else {
      pinTarget.style.removeProperty('position');
      pinTarget.style.removeProperty('top');
    }
  }

  function getScrollPinConfig(section) {
    return {
      enabled: section.dataset.membersWeekScrollPin !== 'false',
      target: section.dataset.membersWeekScrollPinTarget || 'brand_tabs',
      endAtFooter: section.dataset.membersWeekScrollPinEndFooter === 'true',
      endSelector: section.dataset.membersWeekScrollPinEndSelector || '',
      top: getScrollPinTopSetting(section),
      includeHeader: section.dataset.membersWeekScrollPinIncludeHeader === 'true',
      backdropEnabled: section.dataset.membersWeekScrollPinBackdrop !== 'false',
      backdropPaddingTop: getNumber(section.dataset.membersWeekScrollPinBackdropPaddingTop, 0, 0, 48),
      backdropPaddingBottom: getNumber(
        section.dataset.membersWeekScrollPinBackdropPaddingBottom ||
          section.dataset.membersWeekScrollPinBackdropPadding,
        8,
        0,
        48
      ),
      showMarkers: section.dataset.membersWeekScrollPinMarkers === 'true',
      mobile: section.dataset.membersWeekScrollPinMobile !== 'false'
    };
  }

  function syncScrollPinOffsetVars(section, pinTarget) {
    applyScrollPinTopVars(section, pinTarget);
  }

  function clearScrollPinOffsetVars(section, pinTarget) {
    if (!section) return;

    section.style.removeProperty('--mwn-scroll-pin-top');
    section.style.removeProperty('--mwn-scroll-pin-y');
    section.style.removeProperty('--mwn-scroll-pin-announcement-offset');
    section.style.removeProperty('--mwn-scroll-pin-header-offset');

    if (pinTarget) {
      pinTarget.style.removeProperty('--mwn-scroll-pin-top');
      pinTarget.style.removeProperty('--mwn-scroll-pin-y');
      pinTarget.style.removeProperty('--mwn-scroll-pin-announcement-offset');
      pinTarget.style.removeProperty('--mwn-scroll-pin-header-offset');
      pinTarget.style.removeProperty('top');
    }
  }

  function getScrollPinBackground(section) {
    var fromDataset = section.dataset.membersWeekScrollPinBackground;
    if (fromDataset) return fromDataset;

    var fromCss = getComputedStyle(section).getPropertyValue('--mwn-scroll-pin-background').trim();
    return fromCss || '#ffffff';
  }

  function ensurePinBackdropElement(section) {
    if (!section._mwnPinBackdropEl) {
      var backdrop = document.createElement('div');
      backdrop.className = 'members-week-navigation__scroll-pin-backdrop';
      backdrop.setAttribute('aria-hidden', 'true');
      backdrop.hidden = true;
      document.body.appendChild(backdrop);
      section._mwnPinBackdropEl = backdrop;
    }

    return section._mwnPinBackdropEl;
  }

  function hidePinBackdropElement(section) {
    if (section._mwnPinBackdropEl) {
      section._mwnPinBackdropEl.hidden = true;
    }
  }

  function removePinBackdropElement(section) {
    hidePinBackdropElement(section);

    if (section._mwnPinBackdropEl && section._mwnPinBackdropEl.parentNode) {
      section._mwnPinBackdropEl.parentNode.removeChild(section._mwnPinBackdropEl);
    }

    section._mwnPinBackdropEl = null;
  }

  function syncScrollPinBackdrop(section, pinTarget) {
    var config = getScrollPinConfig(section);
    var backdrop = ensurePinBackdropElement(section);

    if (
      !config.backdropEnabled ||
      !section.classList.contains('is-scroll-pin-active') ||
      !pinTarget
    ) {
      hidePinBackdropElement(section);
      section.classList.remove('is-scroll-pin-backdrop');
      return;
    }

    var pinTop = getPinStartOffset(section);
    var backdropTop = getAnnouncementBarOffset();
    var paddingTop = config.backdropPaddingTop;
    var paddingBottom = config.backdropPaddingBottom;
    var aboveTabs = Math.max(0, pinTop - backdropTop);
    var height = aboveTabs + paddingTop + pinTarget.offsetHeight + paddingBottom;
    var background = getScrollPinBackground(section);
    var shadow = getComputedStyle(section).getPropertyValue('--mwn-scroll-pin-backdrop-shadow').trim();

    backdrop.hidden = false;
    backdrop.style.top = backdropTop + 'px';
    backdrop.style.height = height + 'px';
    backdrop.style.background = background;

    if (shadow) {
      backdrop.style.boxShadow = shadow;
    } else {
      backdrop.style.removeProperty('box-shadow');
    }

    section.classList.add('is-scroll-pin-backdrop');
    section.style.setProperty('--mwn-scroll-pin-backdrop-top', backdropTop + 'px');
    section.style.setProperty('--mwn-scroll-pin-backdrop-height', height + 'px');
  }

  function clearScrollPinBackdrop(section) {
    if (!section) return;

    hidePinBackdropElement(section);
    section.classList.remove('is-scroll-pin-backdrop');
    section.style.removeProperty('--mwn-scroll-pin-backdrop-top');
    section.style.removeProperty('--mwn-scroll-pin-backdrop-height');
  }

  function shouldShowScrollPinMarkers(section, config) {
    if (config.showMarkers) return true;
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function whenScrollTriggerReady(callback, attemptsLeft) {
    var attempts = typeof attemptsLeft === 'number' ? attemptsLeft : 120;

    (function tick() {
      if (window.gsap && window.ScrollTrigger) {
        window.gsap.registerPlugin(window.ScrollTrigger);
        callback();
        return;
      }

      if (attempts <= 0) return;
      attempts -= 1;
      window.requestAnimationFrame(tick);
    })();
  }

  function getScrollPinEndElement(section, config) {
    var navHost = section.closest('.shopify-section');

    if (config.endAtFooter) {
      return document.querySelector(
        '.shopify-section-group-footer-group, #shopify-section-footer, .section-footer, footer.shopify-section, [id*="footer"].shopify-section'
      );
    }

    if (config.endSelector) {
      var matches = [];

      try {
        matches = Array.prototype.slice.call(document.querySelectorAll(config.endSelector));
      } catch (error) {
        matches = [];
      }

      for (var index = 0; index < matches.length; index += 1) {
        var match = matches[index];
        var candidate = match.closest('.shopify-section') || match;

        if (!navHost || (navHost.compareDocumentPosition(candidate) & Node.DOCUMENT_POSITION_FOLLOWING)) {
          return candidate;
        }
      }
    }

    return null;
  }

  function getScrollPinEndValue(section) {
    return 'top top+=' + getPinStartOffset(section);
  }

  function resolveScrollPinTarget(section, config) {
    var items = section.querySelector('[data-members-week-items]');
    var brandTabs = section.querySelector('[data-members-week-brand-tabs]');

    if (config.target === 'items' && items) {
      return items;
    }

    if (config.target === 'brand_tabs' || config.target === 'navigation') {
      return brandTabs;
    }

    return brandTabs || items || null;
  }

  function getOffsetWithin(container, element) {
    if (!container || !element || !container.contains(element)) return 0;

    return element.getBoundingClientRect().top - container.getBoundingClientRect().top;
  }

  function getScrollPinTrigger(section, pinTarget) {
    return section.querySelector('[data-members-week-sticky-target]') || pinTarget;
  }

  function getScrollPinStart(section, pinTarget) {
    var trigger = getScrollPinTrigger(section, pinTarget);
    var tabsOffset = trigger === pinTarget ? 0 : getOffsetWithin(trigger, pinTarget);

    return 'top+=' + tabsOffset + ' top+=' + getPinStartOffset(section);
  }

  function clearFixedPinStyles(pinTarget) {
    if (!pinTarget) return;

    if (window.gsap) {
      window.gsap.set(pinTarget, {
        clearProps: 'position,top,left,width,height,zIndex,margin,transform,maxWidth,maxHeight,padding,boxSizing,translate,rotate,scale'
      });
      return;
    }

    pinTarget.style.position = '';
    pinTarget.style.top = '';
    pinTarget.style.left = '';
    pinTarget.style.width = '';
    pinTarget.style.zIndex = '';
    pinTarget.style.background = '';
    pinTarget.style.margin = '';
    pinTarget.style.transform = '';
  }

  function removePinPlaceholder(section) {
    if (section._mwnPinPlaceholder && section._mwnPinPlaceholder.parentNode) {
      section._mwnPinPlaceholder.parentNode.removeChild(section._mwnPinPlaceholder);
    }

    section._mwnPinPlaceholder = null;
  }

  function syncFixedPinPosition(section, pinTarget) {
    if (!pinTarget || !pinTarget.classList.contains('is-scroll-pinned')) return;

    applyScrollPinTopVars(section, pinTarget);

    var pinRect = section._mwnPinRect;

    pinTarget.style.position = 'fixed';
    pinTarget.style.zIndex = '20';
    pinTarget.style.margin = '0';

    if (pinRect) {
      pinTarget.style.left = pinRect.left + 'px';
      pinTarget.style.width = pinRect.width + 'px';
    } else {
      var rect = pinTarget.getBoundingClientRect();
      pinTarget.style.left = rect.left + 'px';
      pinTarget.style.width = rect.width + 'px';
    }

    movePill(section, section.querySelector('[data-members-week-brand-tab].is-active'), false);
    syncScrollPinBackdrop(section, pinTarget);
  }

  function activateFixedPin(section, pinTarget) {
    if (!pinTarget) return;

    var rect = pinTarget.getBoundingClientRect();
    section._mwnPinRect = {
      left: rect.left,
      width: rect.width
    };

    if (!section._mwnPinPlaceholder) {
      section._mwnPinPlaceholder = document.createElement('div');
      section._mwnPinPlaceholder.className = 'members-week-navigation__pin-placeholder';
      section._mwnPinPlaceholder.style.height = pinTarget.offsetHeight + 'px';
      pinTarget.parentNode.insertBefore(section._mwnPinPlaceholder, pinTarget);
    } else {
      section._mwnPinPlaceholder.style.height = pinTarget.offsetHeight + 'px';
    }

    setScrollPinActiveState(section, pinTarget, true);
    syncFixedPinPosition(section, pinTarget);
  }

  function deactivateFixedPin(section, pinTarget) {
    clearFixedPinStyles(pinTarget);
    removePinPlaceholder(section);
    section._mwnPinRect = null;
    clearScrollPinOffsetVars(section, pinTarget);
    clearScrollPinBackdrop(section);
    setScrollPinActiveState(section, pinTarget, false);

    window.requestAnimationFrame(function () {
      movePill(section, section.querySelector('[data-members-week-brand-tab].is-active'), false);
      refreshStickyNav(section);
    });
  }

  function setScrollPinActiveState(section, pinTarget, isActive) {
    if (pinTarget) {
      pinTarget.classList.toggle('is-scroll-pinned', isActive);
    }

    section.classList.toggle('is-scroll-pin-active', isActive);
  }

  function refreshAllScrollPinSections() {
    document.querySelectorAll('[data-members-week-navigation]').forEach(function (section) {
      reapplyScrollPinSettings(section);
    });
  }

  function bindAnnouncementBarSync() {
    if (window._mwnAnnouncementSyncAttached) return;

    var announcementSection = document.querySelector('.announcement-bar-section');
    if (!announcementSection || !window.MutationObserver) return;

    window._mwnAnnouncementSyncAttached = true;

    var observer = new MutationObserver(function () {
      refreshAllScrollPinSections();
    });

    observer.observe(announcementSection, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      subtree: true,
      childList: true
    });

    if (window.ResizeObserver) {
      var resizeObserver = new ResizeObserver(function () {
        refreshAllScrollPinSections();
      });
      resizeObserver.observe(announcementSection);
      window._mwnAnnouncementResizeObserver = resizeObserver;
    }
  }

  function ensureAnnouncementBarSync() {
    bindAnnouncementBarSync();

    if (window._mwnAnnouncementSyncAttached) return;

    window.setTimeout(function () {
      bindAnnouncementBarSync();
      refreshAllScrollPinSections();
    }, 0);
  }

  // CSS 규칙과 동기화: 데스크탑 min(100%, 610px),
  // 모바일(<=989px) min(100%, clamp(292px, 72vw, 610px)).
  function getBrandTabsWidth(innerWidth) {
    var maxWidth = 610;
    var viewportWidth = document.documentElement.clientWidth || innerWidth;

    if (viewportWidth <= 989) {
      var clamped = Math.min(maxWidth, Math.max(292, viewportWidth * 0.72));
      return Math.min(innerWidth, clamped);
    }

    return Math.min(innerWidth, maxWidth);
  }

  function bindFixedPinPosition(section, pinTarget) {
    if (section._mwnFixedPinResizeBound) return;
    section._mwnFixedPinResizeBound = true;

    window.addEventListener('resize', function () {
      if (!pinTarget.classList.contains('is-scroll-pinned')) return;

      var inner = section.querySelector('.members-week-navigation__inner');
      if (!inner) {
        syncFixedPinPosition(section, pinTarget);
        return;
      }

      var innerRect = inner.getBoundingClientRect();
      var tabWidth = getBrandTabsWidth(innerRect.width);
      section._mwnPinRect = {
        left: innerRect.left + (innerRect.width - tabWidth) / 2,
        width: tabWidth
      };
      syncFixedPinPosition(section, pinTarget);
    });
  }

  function reapplyScrollPinSettings(section) {
    if (!section) return;

    var config = getScrollPinConfig(section);
    var pinTarget = resolveScrollPinTarget(section, config);

    applyScrollPinTopVars(section, pinTarget);

    if (!config.enabled) {
      teardownScrollPin(section);
      return;
    }

    if (pinTarget && pinTarget.classList.contains('is-scroll-pinned')) {
      syncFixedPinPosition(section, pinTarget);
    }

    if (section._mwnScrollTrigger) {
      section._mwnScrollTrigger.refresh();
    }

    refreshStickyNav(section);
  }

  function bindScrollPinEditorSync(section) {
    if (!window.Shopify || !window.Shopify.designMode || section._mwnEditorSyncBound) return;
    section._mwnEditorSyncBound = true;

    var observer = new MutationObserver(function (mutations) {
      var shouldReapply = mutations.some(function (mutation) {
        return mutation.type === 'attributes' &&
          mutation.attributeName &&
          mutation.attributeName.indexOf('data-members-week-scroll-pin') === 0;
      });

      if (!shouldReapply) return;

      reapplyScrollPinSettings(section);
    });

    observer.observe(section, {
      attributes: true,
      attributeFilter: [
        'data-members-week-scroll-pin-top',
        'data-members-week-scroll-pin-start-offset',
        'data-members-week-scroll-pin-include-header',
        'data-members-week-scroll-pin-backdrop',
        'data-members-week-scroll-pin-background',
        'data-members-week-scroll-pin-backdrop-padding-top',
        'data-members-week-scroll-pin-backdrop-padding-bottom',
        'data-members-week-scroll-pin-backdrop-padding'
      ]
    });

    section._mwnEditorSyncObserver = observer;
  }

  function teardownScrollPin(section) {
    var pinTarget = section.querySelector('.is-scroll-pinned') ||
      resolveScrollPinTarget(section, getScrollPinConfig(section));

    deactivateFixedPin(section, pinTarget);

    if (section._mwnScrollPinMedia) {
      section._mwnScrollPinMedia.revert();
      section._mwnScrollPinMedia = null;
    }

    if (section._mwnScrollTrigger) {
      section._mwnScrollTrigger.kill(true);
      section._mwnScrollTrigger = null;
    }

    section._mwnFixedPinResizeBound = false;

    section.querySelectorAll('.is-scroll-pinned').forEach(function (element) {
      element.classList.remove('is-scroll-pinned');
    });

    section.classList.remove('is-scroll-pin-active');

    clearScrollPinBackdrop(section);

    var pinTargetForCleanup = section.querySelector('[data-members-week-brand-tabs]');
    clearScrollPinOffsetVars(section, pinTargetForCleanup);

    removePinBackdropElement(section);

    delete section.dataset.membersWeekScrollPinReady;

    if (section._mwnEditorSyncObserver) {
      section._mwnEditorSyncObserver.disconnect();
      section._mwnEditorSyncObserver = null;
      section._mwnEditorSyncBound = false;
    }
  }

  function getHeaderOffset() {
    var header = document.querySelector('.section-header');
    if (header) {
      return header.getBoundingClientRect().height;
    }

    var headerHeight = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue('--header-height'),
      10
    );

    return Number.isFinite(headerHeight) ? headerHeight : 0;
  }

  function createScrollPin(section) {
    if (!window.gsap || !window.ScrollTrigger) return false;

    var config = getScrollPinConfig(section);
    if (!config.enabled) {
      teardownScrollPin(section);
      return true;
    }

    var pinTarget = resolveScrollPinTarget(section, config);
    if (!pinTarget) return false;

    teardownScrollPin(section);
    window.gsap.registerPlugin(window.ScrollTrigger);

    var endTrigger = getScrollPinEndElement(section, config);
    if (!endTrigger) {
      endTrigger = section.closest('.shopify-section') || section;
    }

    var markers = shouldShowScrollPinMarkers(section, config);
    var mediaQuery = config.mobile ? 'all' : '(min-width: 750px)';

    section._mwnScrollPinMedia = window.gsap.matchMedia();
    section._mwnScrollPinMedia.add(mediaQuery, function () {
      bindFixedPinPosition(section, pinTarget);

      var scrollTrigger = getScrollPinTrigger(section, pinTarget);

      section._mwnScrollTrigger = window.ScrollTrigger.create({
        id: 'members-week-nav-pin-' + section.id,
        trigger: scrollTrigger,
        start: function () {
          return getScrollPinStart(section, pinTarget);
        },
        endTrigger: endTrigger,
        end: function () {
          return getScrollPinEndValue(section);
        },
        pinSpacing: false,
        invalidateOnRefresh: true,
        markers: markers,
        onToggle: function (self) {
          if (self.isActive) {
            activateFixedPin(section, pinTarget);
            return;
          }

          deactivateFixedPin(section, pinTarget);
        },
        onRefresh: function (self) {
          if (self.isActive) {
            syncFixedPinPosition(section, pinTarget);
          }
        }
      });

      section.dataset.membersWeekScrollPinReady = 'true';

      return function () {
        if (section._mwnScrollTrigger) {
          section._mwnScrollTrigger.kill(true);
          section._mwnScrollTrigger = null;
        }
        deactivateFixedPin(section, pinTarget);
      };
    });

    return true;
  }

  function setupScrollPin(section) {
    if (!section) return;

    whenScrollTriggerReady(function () {
      createScrollPin(section);
      refreshStickyNav(section);
    });
  }

  function bindScrollPinEvents(section) {
    if (section._mwnScrollPinEventsBound) return;
    section._mwnScrollPinEventsBound = true;

    window.addEventListener('load', function () {
      setupScrollPin(section);
    });

    window.addEventListener('resize', function () {
      refreshStickyNav(section);
    });

    if (window.ResizeObserver) {
      var observeTarget = section.querySelector('[data-members-week-brand-tabs]') || section;
      var resizeObserver = new ResizeObserver(function () {
        refreshStickyNav(section);
      });
      resizeObserver.observe(observeTarget);
      section._mwnScrollPinResizeObserver = resizeObserver;
    }
  }

  function initScrollPin(section) {
    var config = getScrollPinConfig(section);
    var pinTarget = resolveScrollPinTarget(section, config);

    bindScrollPinEditorSync(section);
    applyScrollPinTopVars(section, pinTarget);

    if (!config.enabled) return;

    bindScrollPinEvents(section);
    setupScrollPin(section);
  }

  var SCROLL_STATE_KEY = 'fila:members-week:scroll-state';
  var SCROLL_STATE_TTL = 30 * 60 * 1000;

  function getMembersWeekPageKey() {
    return window.location.pathname + window.location.search;
  }

  function saveMembersWeekScrollState(section, link) {
    try {
      var activeBrandTab = section.querySelector('[data-members-week-brand-tab].is-active');
      var activeNavItem = section.querySelector('[data-members-week-item].is-active');
      var activeProductTab = document.querySelector(
        '[data-members-week-tab-products] [data-home-tab-btn].active:not(.members-week-filter-hidden)'
      );
      var href = link.getAttribute('href') || '';
      var handleMatch = href.match(/\/products\/([^/?#]+)/);

      sessionStorage.setItem(SCROLL_STATE_KEY, JSON.stringify({
        path: getMembersWeekPageKey(),
        scrollY: window.scrollY || window.pageYOffset || 0,
        brand: activeBrandTab ? activeBrandTab.getAttribute('data-members-week-brand') : 'primary',
        navSectionIndex: activeNavItem
          ? activeNavItem.getAttribute('data-members-week-product-section-index')
          : null,
        navTabIndex: activeNavItem
          ? activeNavItem.getAttribute('data-members-week-product-tab-index')
          : null,
        productTabTarget: activeProductTab
          ? activeProductTab.getAttribute('data-tab-target')
          : null,
        productHandle: handleMatch ? handleMatch[1] : null,
        ts: Date.now()
      }));
    } catch (error) {
      // sessionStorage unavailable
    }
  }

  function readMembersWeekScrollState() {
    try {
      var raw = sessionStorage.getItem(SCROLL_STATE_KEY);
      if (!raw) return null;

      var state = JSON.parse(raw);
      if (!state || state.path !== getMembersWeekPageKey()) return null;
      if (state.ts && Date.now() - state.ts > SCROLL_STATE_TTL) {
        sessionStorage.removeItem(SCROLL_STATE_KEY);
        return null;
      }

      return state;
    } catch (error) {
      return null;
    }
  }

  function clearMembersWeekScrollState() {
    try {
      sessionStorage.removeItem(SCROLL_STATE_KEY);
    } catch (error) {
      // sessionStorage unavailable
    }
  }

  function findNavItemForState(section, brand, state) {
    if (!state) return null;

    var visibleItems = getVisibleItems(section, brand || 'primary');
    var sectionIndex = state.navSectionIndex;
    var tabIndex = state.navTabIndex;

    if (sectionIndex == null && tabIndex == null) return null;

    for (var index = 0; index < visibleItems.length; index += 1) {
      var item = visibleItems[index];
      var itemSectionIndex = item.getAttribute('data-members-week-product-section-index');
      var itemTabIndex = item.getAttribute('data-members-week-product-tab-index');
      var sectionMatches = sectionIndex == null || itemSectionIndex === String(sectionIndex);
      var tabMatches = tabIndex == null || itemTabIndex === String(tabIndex);

      if (sectionMatches && tabMatches) {
        return item;
      }
    }

    return null;
  }

  function activateSavedProductTab(section, state) {
    if (!state || !state.productTabTarget) return;

    var productSection = showProductSection(section, state.navSectionIndex || 1);
    if (!productSection) return;

    var tabs = Array.prototype.slice.call(productSection.querySelectorAll('[data-home-tab-btn]'));
    var targetTab = tabs.filter(function (tab) {
      return tab.getAttribute('data-tab-target') === state.productTabTarget;
    })[0];

    if (targetTab && !targetTab.classList.contains('active')) {
      targetTab.click();
    }
  }

  function scrollToMembersWeekTarget(section, state) {
    var headerOffset = getHeaderOffset();
    var targetTop = null;

    if (state && state.productHandle) {
      var productLink = document.querySelector(
        '[data-members-week-tab-products] a[href*="/products/' + state.productHandle + '"]'
      );

      if (productLink) {
        targetTop = productLink.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
      }
    }

    if (targetTop == null && state && typeof state.scrollY === 'number') {
      targetTop = state.scrollY;
    }

    if (targetTop == null || !Number.isFinite(targetTop)) return;

    window.scrollTo(0, Math.max(0, targetTop));
    refreshStickyNav(section);
  }

  function scheduleMembersWeekScrollRestore(section, state) {
    var attempts = 0;
    var maxAttempts = 12;

    function applyRestore() {
      attempts += 1;
      scrollToMembersWeekTarget(section, state);

      if (attempts < maxAttempts) {
        window.requestAnimationFrame(function () {
          window.setTimeout(applyRestore, attempts < 4 ? 50 : 120);
        });
      }
    }

    whenScrollTriggerReady(function () {
      window.requestAnimationFrame(function () {
        window.setTimeout(applyRestore, 80);
      });
    });
  }

  function restoreMembersWeekScrollState(section) {
    var state = readMembersWeekScrollState();
    if (!state) return false;

    var brand = state.brand === 'secondary' ? 'secondary' : 'primary';
    setActive(section, brand, false);

    var navItem = findNavItemForState(section, brand, state);
    if (navItem) {
      setActiveItem(section, navItem);
    }

    activateSavedProductTab(section, state);

    scheduleMembersWeekScrollRestore(section, state);
    clearMembersWeekScrollState();
    return true;
  }

  function bindMembersWeekScrollStateSaver() {
    if (window._filaMembersWeekScrollSaverBound) return;
    window._filaMembersWeekScrollSaverBound = true;

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      var link = event.target.closest('[data-members-week-tab-products] a[href*="/products/"]');
      if (!link || link.target === '_blank') return;

      var navSection = document.querySelector('[data-members-week-navigation]');
      if (!navSection) return;

      saveMembersWeekScrollState(navSection, link);
    }, true);
  }

  function bindMembersWeekScrollStateRestore() {
    if (window._filaMembersWeekScrollRestoreBound) return;
    window._filaMembersWeekScrollRestoreBound = true;

    window.addEventListener('pageshow', function (event) {
      if (!document.querySelector('[data-members-week-navigation]')) return;

      if (event.persisted) {
        clearMembersWeekScrollState();
      }
    });
  }

  function initSection(section) {
    if (!section || section.dataset.membersWeekNavigationReady === 'true') return;
    section.dataset.membersWeekNavigationReady = 'true';

    var tabs = section.querySelectorAll('[data-members-week-brand-tab]');
    var items = section.querySelectorAll('[data-members-week-item]');
    var activeTab = section.querySelector('[data-members-week-brand-tab].is-active') || tabs[0];
    var initialBrand = activeTab ? activeTab.getAttribute('data-members-week-brand') : 'primary';
    var pendingScrollRestore = Boolean(readMembersWeekScrollState());

    if (pendingScrollRestore) {
      window.setTimeout(function () {
        if (!restoreMembersWeekScrollState(section)) {
          setActive(section, initialBrand, false);
        }
      }, 0);
    } else {
      setActive(section, initialBrand, false);
    }

    items.forEach(function (item) {
      item.addEventListener('click', function (event) {
        var sectionIndex = item.getAttribute('data-members-week-product-section-index');
        var tabIndex = item.getAttribute('data-members-week-product-tab-index');

        if (sectionIndex || tabIndex) {
          event.preventDefault();
          setActiveItem(section, item);
        }
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var brand = tab.getAttribute('data-members-week-brand');
        if (tab.classList.contains('is-active')) return;
        setActive(section, brand, true);
      });
    });

    document.addEventListener('members-week-products:tab-change', function (event) {
      var brand = event.detail && event.detail.brand;
      if (brand !== 'primary' && brand !== 'secondary') return;

      var source = event.detail && event.detail.source;
      if (source && getProductSections(section).indexOf(source) === -1) return;

      var current = section.querySelector('[data-members-week-brand-tab].is-active');
      applyProductOriginBrandTabVisibility(section, brand);
      if (current && current.getAttribute('data-members-week-brand') === brand) {
        movePill(section, current, false);
        return;
      }

      setActive(section, brand, true);
    });

    window.addEventListener('resize', function () {
      // pinned 상태는 bindFixedPinPosition 리사이즈 핸들러가 너비 동기화 후 pill 재계산.
      if (section.querySelector('[data-members-week-brand-tabs].is-scroll-pinned')) return;
      var current = section.querySelector('[data-members-week-brand-tab].is-active');
      movePill(section, current, false);
    });

    initScrollPin(section);
  }

  function init() {
    ensureAnnouncementBarSync();

    if (document.querySelector('[data-members-week-navigation]')) {
      if ('scrollRestoration' in window.history) {
        window.history.scrollRestoration = 'manual';
      }
      bindMembersWeekScrollStateSaver();
      bindMembersWeekScrollStateRestore();
    }

    document.querySelectorAll('[data-members-week-navigation]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-members-week-navigation]');
    if (section) {
      delete section.dataset.membersWeekNavigationReady;
      initSection(section);
      whenScrollTriggerReady(function () {
        ensureAnnouncementBarSync();
        reapplyScrollPinSettings(section);
      });
      return;
    }

    init();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('[data-members-week-navigation]');
    if (section) {
      teardownScrollPin(section);
    }
  });

  document.addEventListener('shopify:section:select', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-members-week-navigation]')
      : null;

    if (section) {
      reapplyScrollPinSettings(section);
    }

    if (window.ScrollTrigger) {
      window.ScrollTrigger.refresh();
    }
  });
})();
